const tabs = [
  { label: "Transition History", value: "transport" },
  { label: "State History", value: "state" },
];

const CylinderHistoryTabs = ({ currentTab, setCurrentTab }) => {
  return (
    <div className="flex gap-4 text-lg pb-3">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={`border-b-3 transition-all hover:text-[#0F6FDF] ${
            currentTab === tab.value
              ? "text-[#0F6FDF] border-[#0F6FDF]"
              : "border-transparent"
          }`}
          onClick={() => setCurrentTab(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default CylinderHistoryTabs;
